/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {  Observable } from 'rxjs';
import { PuntRecollidaService } from '../../../controllers/PuntRecollida';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGPostFormService } from '../../yasag-post.service';


@Injectable()
export class PuntRecollidaPartialUpdateFormService extends YASAGPostFormService<__model.PuntRecollida> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    data: new FormGroup({
      id: new FormControl({value: undefined, disabled: false}, []),
      codi_element: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(256), Validators.minLength(1)]),
      nom: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(256)]),
      point: new FormGroup({
        type: new FormControl({value: undefined, disabled: false}, [Validators.required]),
        geometries: new FormArray([], [Validators.required]),
      }, []),
      polygon: new FormGroup({
        type: new FormControl({value: undefined, disabled: false}, [Validators.required]),
        geometries: new FormArray([], [Validators.required]),
      }, []),
      districte: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(256)]),
      barri: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(256)]),
      adreca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      observacions_ca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      observacions_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      observacions_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      ocultar: new FormControl({value: undefined, disabled: false}, []),
      fraccio: new FormControl({value: undefined, disabled: false}, []),
      tipus_servei: new FormControl({value: undefined, disabled: false}, []),
      horaris: new FormArray([], []),
    }, [Validators.required]),
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
    id: new FormControl({value: undefined, disabled: false}, [Validators.required]),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: PuntRecollidaService,
  ) {
    super('PuntRecollidaPartialUpdate', apiConfigService, ngZone);
    this.init();
  }

  public addDataPointGeometries( geometries: number = 1, position?: number, value?: any): void {
    const control = <FormArray>this.form['controls']['data']['controls']['point']['controls']['geometries'];
    const fg = new FormGroup({
      type: new FormControl({value: undefined, disabled: false}, [Validators.required]),
      coordinates: new FormControl([], [Validators.required]),
    }, []);
    __utils.addField(control,geometries, fg, position, value);
  }

  public removeDataPointGeometries( i: number): void {
    const control = <FormArray>this.form['controls']['data']['controls']['point']['controls']['geometries'];
    control.removeAt(i);
  }

  public addDataPolygonGeometries( geometries: number = 1, position?: number, value?: any): void {
    const control = <FormArray>this.form['controls']['data']['controls']['polygon']['controls']['geometries'];
    const fg = new FormGroup({
      type: new FormControl({value: undefined, disabled: false}, [Validators.required]),
      coordinates: new FormControl([], [Validators.required]),
    }, []);
    __utils.addField(control,geometries, fg, position, value);
  }

  public removeDataPolygonGeometries( i: number): void {
    const control = <FormArray>this.form['controls']['data']['controls']['polygon']['controls']['geometries'];
    control.removeAt(i);
  }

  public addDataHoraris( horaris: number = 1, position?: number, value?: any): void {
    const control = <FormArray>this.form['controls']['data']['controls']['horaris'];
    const fg = new FormGroup({
      id: new FormControl({value: undefined, disabled: false}, []),
      dia_setmana: new FormControl({value: undefined, disabled: false}, [Validators.required]),
      hora_inici: new FormControl({value: undefined, disabled: false}, []),
      hora_fi: new FormControl({value: undefined, disabled: false}, []),
      hora_tanc_migdia: new FormControl({value: undefined, disabled: false}, []),
      hora_obert_tarda: new FormControl({value: undefined, disabled: false}, []),
    }, []);
    __utils.addField(control,horaris, fg, position, value);
  }

  public removeDataHoraris( i: number): void {
    const control = <FormArray>this.form['controls']['data']['controls']['horaris'];
    control.removeAt(i);
  }

  submit(value: typeof this.form.value | false = false): Observable<__model.PuntRecollida> {
    const result = val => this.service.partialUpdate(val);
    return this._submit('__model.PuntRecollida', result, 'data', value, true );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.PuntRecollida> {
    if (submit) {
      this.submit(value);
    }
    return this._listen(value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    while ((<FormArray>this.form['controls']['data']['controls']['point']['controls']['geometries']).length) {
      this.removeDataPointGeometries(0);
    }
    if (value && value['data'] && value['data']['point'] && value['data']['point']['geometries']) {
      this.addDataPointGeometries(value['data']['point']['geometries'].length);
    }
    while ((<FormArray>this.form['controls']['data']['controls']['polygon']['controls']['geometries']).length) {
      this.removeDataPolygonGeometries(0);
    }
    if (value && value['data'] && value['data']['polygon'] && value['data']['polygon']['geometries']) {
      this.addDataPolygonGeometries(value['data']['polygon']['geometries'].length);
    }
    while ((<FormArray>this.form['controls']['data']['controls']['horaris']).length) {
      this.removeDataHoraris(0);
    }
    if (value && value['data'] && value['data']['horaris']) {
      this.addDataHoraris(value['data']['horaris'].length);
    }
    super.reset(value, true); 
  }
  patch(value: typeof this.form.value): void {
    if (value && value['data'] && value['data']['point'] && value['data']['point']['geometries']) {
      while (this.form.value['data']['point']['geometries'].length > 0) {
        this.removeDataPointGeometries(0);
      }
      if (value['data']['point']['geometries'].length > this.form.value['data']['point']['geometries'].length) {
        this.addDataPointGeometries(value['data']['point']['geometries'].length - this.form.value['data']['point']['geometries'].length);
      }
    }
    if (value && value['data'] && value['data']['polygon'] && value['data']['polygon']['geometries']) {
      while (this.form.value['data']['polygon']['geometries'].length > 0) {
        this.removeDataPolygonGeometries(0);
      }
      if (value['data']['polygon']['geometries'].length > this.form.value['data']['polygon']['geometries'].length) {
        this.addDataPolygonGeometries(value['data']['polygon']['geometries'].length - this.form.value['data']['polygon']['geometries'].length);
      }
    }
    if (value && value['data'] && value['data']['horaris']) {
      while (this.form.value['data']['horaris'].length > 0) {
        this.removeDataHoraris(0);
      }
      if (value['data']['horaris'].length > this.form.value['data']['horaris'].length) {
        this.addDataHoraris(value['data']['horaris'].length - this.form.value['data']['horaris'].length);
      }
    }
    this.form.patchValue(value);
  }
}
